/**
 * UI-6b Task 12 — ActiveCallsCounter config editor.
 *
 * Phase 1: no settings — see Renderer.tsx for the placeholder rationale.
 */
import type { JSX } from 'react'
import type { ActiveCallsCounterConfig } from './Renderer.js'

interface Props {
  config: ActiveCallsCounterConfig
  onChange: (next: ActiveCallsCounterConfig) => void
}

export function ActiveCallsCounterConfigEditor(_props: Props): JSX.Element {
  return (
    <div
      data-testid="active-calls-counter-config-editor"
      className="text-sm text-gray-500"
    >
      <p>No settings.</p>
    </div>
  )
}
